
import ModalFooter from './Footer';

export default {
  components: {
    ModalFooter
  }
};
